
import BlockImagesTextTemplate from './BlockImagesTextTemplate';

export default {
  name: 'BlockImagesTextStandardTab',
  components: { BlockImagesTextTemplate },
  props: {
    title: {
      type: String,
    },
    text: {
      type: String,
    },
    classes: {
      type: Object,
      default: () => {},
    },
    pictos: {
      type: Array,
    },
    isOverlay: Boolean,
    isRecipePage: Boolean,
  },
};
